<template>
  <div class="card">
    <div class="pb-0 card-header mb-0">
      <div class="d-flex justify-content-between">
        <h6 class="align-self-center">{{ title }}</h6>
        <router-link to="/vendor-performance">
          <button class="btn btn-link btn-xs" v-if="labels.length > 0">View all</button>
        </router-link>
      </div>
    </div>
    <div class="p-3 card-body">
      <div class="chart">
        <canvas id="chart-line" class="chart-canvas" height="300"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
// import EmptyState from "../../views/components/EmptyState.vue";
const endpoint = require("../../router/endpoint");

export default {
  name: "gradient-line-chart",

  components: {
    // EmptyState
  },

  props: {
    title: {
      type: String,
      default: "Supplier Evaluation"
    },
    detail1: {
      type: String,
      default: "4% more"
    },
    detail2: {
      type: String,
      default: "in 2021"
    }
  },

  data() {
    return {
      labels: [],
      values: []
    };
  },

  methods: {
    getEvaluation() {
      this.labels = [];
      this.values = [];
      const values = {
        partner_id: localStorage.getItem("partner_id"),
        limit: 12,
        offset: 0
      };
      this.axios
        .post(endpoint.EVALUATION_LIST, values, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        })
        .then((response) => {
          if (response.data.response_code === "0000") {
            response.data.data.forEach((line) => {
              this.labels.push(line.month + " " + line.year);
              this.values.push(line.summary_average);
            });
            var ctx1 = document.getElementById("chart-line").getContext("2d");

            var gradientStroke1 = ctx1.createLinearGradient(0, 230, 0, 50);

            gradientStroke1.addColorStop(1, "rgba(94, 114, 228, 0.2)");
            gradientStroke1.addColorStop(0.2, "rgba(94, 114, 228, 0.0)");
            gradientStroke1.addColorStop(0, "rgba(94, 114, 228, 0)");
            new Chart(ctx1, {
              type: "line",
              data: {
                labels: this.labels,
                datasets: [
                  {
                    label: "Score",
                    tension: 0.4,
                    borderWidth: 0,
                    pointRadius: 0,
                    borderColor: "#4BB543 ",
                    backgroundColor: gradientStroke1,
                    // eslint-disable-next-line no-dupe-keys
                    borderWidth: 3,
                    fill: true,
                    data: this.values,
                    maxBarThickness: 6
                  }
                ]
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    display: false
                  }
                },
                interaction: {
                  intersect: false,
                  mode: "index"
                },
                scales: {
                  y: {
                    grid: {
                      drawBorder: false,
                      display: true,
                      drawOnChartArea: true,
                      drawTicks: false,
                      borderDash: [5, 5]
                    },
                    ticks: {
                      display: true,
                      padding: 10,
                      color: "#fbfbfb",
                      font: {
                        size: 11,
                        family: "Open Sans",
                        style: "normal",
                        lineHeight: 2
                      }
                    }
                  },
                  x: {
                    grid: {
                      drawBorder: false,
                      display: false,
                      drawOnChartArea: false,
                      drawTicks: false,
                      borderDash: [5, 5]
                    },
                    ticks: {
                      display: true,
                      color: "#ccc",
                      padding: 20,
                      font: {
                        size: 11,
                        family: "Open Sans",
                        style: "normal",
                        lineHeight: 2
                      }
                    }
                  }
                }
              }
            });
            // this.labels = response.data.data;
          } else {
            if (response.data.response_code !== "4000") {
              this.$notify({
                type: "warn",
                title: "Warning",
                text: response.data.message
              });
            }
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
            type: "error",
            title: "Something went wrong!",
            text: e.response.data.message
          });
        });
    }
  },
  mounted() {
    this.getEvaluation();
  }
};
</script>
